import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ExpenseFormReimbursementCustomization } from '@webapp/modules/expense/entities/enums'
import { type IReimbursementSettingsRepository } from '../../../business-logic/interfaces/IReimbursementSettingsRepository'
import { type ReimbursementSettingsApiModel } from '../../api-models/ReimbursementSettingsApiModel'

interface Dependency {
  httpClient: IHttpClient
}

export class ReimbursementSettingsRepository implements IReimbursementSettingsRepository {
  constructor(private readonly deps: Dependency) {}

  async get(): Promise<ExpenseFormReimbursementCustomization> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<ReimbursementSettingsApiModel>
      >(`/api/v3/kvstore/system-preferences/expense-reimbursement/`)

      return res.data.data.value as ExpenseFormReimbursementCustomization
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
